import LazyLoad from "react-lazyload";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";

const Transport = () => {
  const homeMenu = [
    // { label: "Admission Notification ", link: "/howtoapply" },
    { label: "Fee Structure", link: "/feestructure" },
    { label: "Prospectus ", link: "/Prospectus" },
    {
      label: "Virtual School Tour ",
      link: "https://iviewd.com/lotus_valley_gurgaon/",
    },
    { label: "School Schedule ", link: "/schoolSchedule" },
    {
      label: "Transport",
      link: "",
      subMenu: [
        { label: "Transport", link: "/transport" },
        { label: "Bus Routes", link: "/busRoute" },
      ],
    },

    { label: "Special Education", link: "/specialEdu" },
    { label: "Bonding With Parents", link: "/bondingwithparents" },
    // { label: "Career Counselling", link: "/careerCounselling" },
    {
      label: "Meal Menu",
      link: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/School-Menu.pdf",
    },
    { label: "CBSE Results", link: "/CBSEResult" },
    { label: "Transfer Certificate", link: "/tc" },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/apply.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Transport"
                breadEnd="Transport"
                breadMid="Transport"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <p>
                The school provides the students with comfortable, well
                maintained, air conditioned buses. Keeping in view the safety
                and security of our learners, the buses are equipped with Global
                Positioning System (GPS), CCTV, and First Aid kit.
              </p>
              <p>
                All our bus drivers and conductors are periodically trained on
                traffic rules and regulations.
              </p>
              <LazyLoad>
                {" "}
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/bus-routes-banr3.png"
                  className="img-fluid wid-100 mb-4"
                  alt="Lotus Valley School Gurgaon"
                />
              </LazyLoad>
              <p>
                Each bus has a driver, guard and a lady attendant accompanying
                the students. The guards carry school mobiles and can be tracked
                easily through this medium as well.
              </p>
              <p>
                The transport facility is available to the students strictly on
                first come first serve basis. One can refer to the school
                almanac for the detailed guidelines on school transport.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Transport;
